'use strict';
angular
    .module('newspaperStandbyDraftModule', [
        'newspaperStandbyDraftRouterModule',
        'trsPrintModule',
        'newspaperTodaysDraftRouterModule',
    ])
    .controller('newspaperStandbyDraftCtrl', [
        '$scope',
        '$filter',
        '$q',
        '$state',
        '$cacheFactory',
        '$window',
        '$stateParams',
        'trsHttpService',
        'initSingleSelecet',
        'editNewspaperService',
        'editingCenterService',
        'trsspliceString',
        'editcenterRightsService',
        'trsPrintService',
        'storageListenerService',
        'localStorageService',
        'modalDialog',
        'newMediaService',
        'messagePublishService',
        'publicToolService',
        function(
            $scope,
            $filter,
            $q,
            $state,
            $cacheFactory,
            $window,
            $stateParams,
            trsHttpService,
            initSingleSelecet,
            editNewspaperService,
            editingCenterService,
            trsspliceString,
            editcenterRightsService,
            trsPrintService,
            storageListenerService,
            localStorageService,
            modalDialog,
            newMediaService,
            messagePublishService,
            publicToolService
        ) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 20,
                    ITEMCOUNT: 0,
                    PAGECOUNT: 0,
                };
                $scope.childStatus = {
                    // 图片数组的string
                    checkString: 'DOC_PICTURELIST',
                    // 图片数组中表示url地址的string
                    picString: 'SRCPICURL',
                    originPicUrl: 'SRCPICURL'
                };
                $scope.params = {
                    serviceid: 'mlf_paper',
                    methodname: 'queryDaiYongDocs',
                    paperid: $stateParams.paperid,
                    // oprtime: '1m',
                };
                $scope.status = {
                    isShowList: true,
                    // 面板是否打开,默认打开第一个
                    isPanelOpenArray: {
                        0: true,
                    },
                    batchOperateBtn: {
                        hoverStatus: '',
                        clickStatus: '',
                    },
                    hasphoto: false, // 是否是图集稿
                    hasphotoflag: true, // 判断是否人为点击图集切换模式
                    dygpreview: 0,
                    dygedit: 0,
                    // 初始化参数
                    quantitys: '0',
                    // 编辑页面
                    newspaperEdit: editNewspaperService.initNewspaperEdit(),
                    // 所有版面
                    allBanmian: [],
                    isESSearch: false,
                    cachedName: 'newspaperStandbyDocuments', // 缓存key
                    selectArrayIdCache: [],
                    cacheOpenedPanel: {}, // 记忆打开的面板
                };
                $scope.data = {
                    // 当前站点id
                    paperId: $stateParams.paperId,
                    panels: [],
                    selectedArray: [],
                    currSite: '',
                    cacheData: [],
                    selectedCurrents: [],
                    curSelectedArray: [],
                    allDocuments: [],
                    selectedArrayObj: [],
                    daiyongDocsList: [],
                    BanMian: {
                        selectedBanMian: {},
                        BanMianArray: [],
                    },
                    word: [],
                    selectAllWords: 0, // 列表下选中总字数
                    ownerArr: [],
                    AllBMRights: {},
                    orderArray: editingCenterService.getNewspaperOrder(), // 下拉框排序
                    selectedOrder: editingCenterService.getNewspaperOrder()[0],
                };
            }

            /**
             * [initData description]初始化数据
             *
             * @return  {[type]}  [return description]
             */
            function initData() {
                initDropDown();
                // requestData();
                listenStorage();
                // //按钮权限
                editcenterRightsService.initNewspaperListBtn('paper.dyg', $stateParams.paperid).then(function(data) {
                    $scope.status.btnRights = data;
                    $scope.data.AllBMRights['paper.dyg'] = data;
                    getObjLength($scope.status.btnRights);
                });
                // 获取报纸的信息
                editNewspaperService.queryCurrSite($stateParams.paperid).then(function(data) {
                    $scope.data.currSite = data;
                });
            }
            
            // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
            // $scope.requestData = function() {
            //     requestData();
            // };
            
            /**
             * [getObjLength description]获得权限长度
             * @param  {[type]} obj [description]
             * @return {[type]}     [description]
             */
            function getObjLength(obj) {
                var size = 0,
                    key;
                for (key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        size++;
                    }
                }
                $scope.status.btnLength = size;
            }

            /**
             * [selectItem description]单选某稿件
             *
             * @param   {[type]}  item   [item description]
             * @param   {[type]}  items  [items description]
             *
             * @return  {[type]}         [return description]
             */
            $scope.selectItem = function(item, items) {
                var num = -1;
                for (var index = 0; index < $scope.data.selectedArray.length; index++) {
                    if ($scope.data.selectedArray[index].METADATAID == item.METADATAID) {
                        num = index;
                        break;
                    }
                }
                if (num > -1) {
                    $scope.data.selectedArray.splice(num, 1);
                } else {
                    $scope.data.selectedArray.push(item);
                }
                // 选中的报纸的字数
                var selectedNum = 0;
                $scope.data.selectedArray.map((item) => {
                    if (items.DOCUMENTS.includes(item)){
                        selectedNum = selectedNum + Number(item.DOCWORDSCOUNT);
                    }
                });
                $scope.data.word[$scope.data.panels.indexOf(items)].selcetedWord = selectedNum;
                selectedArrayCahe($scope.data.selectedArray);
                $scope.loadingPromise = editNewspaperService.getAllBMRights($scope.data, $state.params.paperid, item.CHANNELID, 'paper.dyg').then(function(data) {
                    $scope.status.btnRights = data;
                });
            };

            /**
             * [listenStorage description]监听本地缓存
             * @return {[promise]} [description] promise
             */
            function listenStorage() {
                storageListenerService.listenNewspaper(function() {
                    requestData();
                    storageListenerService.removeListener('newspaper');
                }, $scope);
                $scope.$on('$destroy', function() {
                    localStorageService.remove('newspaperPreviewSelectArray');
                    localStorageService.remove('newspaperPreviewCache');
                });
            }

            /**
             * [selectAllItem description]全选或者取消全选的操作
             *
             * @return  {[type]}  [return description]
             */
            $scope.selectAllItem = function() {
                if ($scope.data.selectedArray.length === $scope.data.daiyongDocsList.length && $scope.data.daiyongDocsList.length > 0) {
                    $scope.data.selectedArray = [];
                } else {
                    $scope.data.selectedArray = [];
                    for (var i = 0; i < $scope.data.daiyongDocsList.length; i++) {
                        $scope.data.selectedArray.push($scope.data.daiyongDocsList[i]);
                    }
                }
                selectedArrayCahe($scope.data.selectedArray);
            };

            /*
             * [isChecked description] 点击单选
             * @item {[type]} [description]  当前选择值
             */
            $scope.isChecked = function(item) {
                // page
                return getIndex(item) >= 0;
            };

            /**
             * [getIndex description] 单选方法
             *
             * @param   {[type]}  item  [item description]当前选择值
             *
             * @return  {[type]}        [return description]
             */
            function getIndex(item) {
                var selectedArray = $scope.data.selectedArray;
                for (var index = 0; index < selectedArray.length; index++) {
                    if (selectedArray[index].METADATAID == item.METADATAID) {
                        return index;
                    }
                }
                return -1;
            }

            /**
             * [cacheDate description] 缓存数据以提高渲染速度
             *
             * @param   {[type]}  data  [item description]
             * 
             * @return {[type]} [description]
             */
            function cacheDate(data) {
                if ($cacheFactory.get($scope.status.cachedName)) {
                    $cacheFactory.get($scope.status.cachedName).destroy();
                }
                var copyedData = angular.copy(data);
                var cache = $cacheFactory($scope.status.cachedName);
                var documents = [];
                for (var i in copyedData) {
                    cache.put(copyedData[i].BANMIANID, copyedData[i].DOCUMENTS);
                    documents.push(copyedData[i].DOCUMENTS);
                    if (i > 0) {
                        copyedData[i].DOCUMENTS = [];
                    }
                }
                $scope.data.panels = copyedData;
                listItemCache(documents);
            }

            /**
             * [cacheDate description] 缓存存储
             * @param {[type]} data [description]
             * @return {[type]} [description]
             */
            function listItemCache(data) {
                var cachePreviewMetadataid = [];
                $scope.data.selectedArrayObj = [];
                angular.forEach(data, function(data, index, array) {
                    angular.forEach(data, function(_data, _index, _array) {
                        cachePreviewMetadataid.push({
                            METADATAID: _data.METADATAID,
                            PAPERSTATUSNAME: _data.PAPERSTATUSNAME,
                            NEWSPAPERTYPE: 0,
                        });
                        $scope.data.selectedArrayObj.push(_data);
                    });
                });
                localStorageService.set('newspaperPreviewCache', cachePreviewMetadataid);
            }

            /**
             * [selectedArrayCahe description] 缓存当前选中项
             * @param {[type]} array [description]  选中对象
             * @return {[type]}       [description]
             */
            function selectedArrayCahe(array) {
                var selectedArray = angular.copy(array);
                var selectedArrayMetadaid = [];
                angular.forEach(selectedArray, function(data, index) {
                    selectedArrayMetadaid.push(data.METADATAID);
                });
                localStorageService.set('newspaperPreviewSelectArray', selectedArrayMetadaid); // paged
            }

            // 监听预览页 按钮点击
            $window.addEventListener('storage', function(e) {
                $scope.data.selectedCurrents = angular.copy(localStorageService.get('newspaperPreviewSelectArray')); // page
                $scope.$apply(function() {
                    selectCurArray($scope.data.selectedCurrents);
                });
            });

            /**
             * [selectCurArray description] 遍历出选择对象
             * @param  {[type]} curSelectedArray [description]  当前选中对象
             * @return {[type]}       [description]
             */
            function selectCurArray(curSelectedArray) {
                // o
                if (curSelectedArray === null) {
                    return;
                }
                // var arrays=[];
                $scope.data.selectedArray = [];
                for (var i = 0; i < curSelectedArray.length; i++) {
                    for (var j = 0; j < $scope.data.selectedArrayObj.length; j++) {
                        if (curSelectedArray[i] === $scope.data.selectedArrayObj[j].METADATAID) {
                            $scope.data.selectedArray.push($scope.data.selectedArrayObj[j]);
                        }
                    }
                }
            }

            /**
             * [requestData description]数据请求函数
             * @return {[type]} [description]
             */
            function requestData() {
                var deferred = $q.defer();
                // 判断是否启用ES检索
                var params = $scope.status.isESSearch ? getESSearchParams() : angular.copy($scope.params);
                if ($scope.status.isShowList) {
                    params.PageSize = $scope.page.PAGESIZE;
                    params.PAGEINDEX = $scope.page.CURRPAGE;
                    if (!$scope.status.isESSearch) {
                        params.NoPage = !$scope.status.isESSearch && $scope.status.isShowList;
                        params.ChannelId = $scope.data.BanMian.selectedBanMian.CHANNELID;
                    }
                } else {
                    params.ChannelId = '';
                }
                params.OrderType = $scope.data.selectedOrder.value;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    var fileterObj = {};
                    if ($scope.status.isShowList) {
                        $scope.data.selectAllWords = 0;
                        $scope.data.items = $scope.data.panels = data.DATA;
                        if ($scope.data.selectedDocType.value && $scope.data.selectedDocType.value === '2' && $scope.status.hasphotoflag === true) {
                            $scope.status.hasphoto = true;
                        } else {
                            $scope.status.hasphoto = false;
                        }
                        $scope.page = data.PAGER;
                        fileterObj = editNewspaperService.extractParametersList(data.DATA, {
                            namekey: 'OWNERTRUENAME',
                            valuekey: 'OWNERNAME',
                            title: '所有者'
                        });
                        $scope.data.ownerArr = $scope.data.ownerArr.concat(fileterObj.nameArr);
                        $scope.data.ownerArr = $filter('unique')($scope.data.ownerArr, 'name');
                        $scope.data.filterReviseItem = fileterObj.filterReviseItem; // 因为待修订稿件不能被选中,用来存储非待修订的稿件
                        editNewspaperService.liebiaoListItemCache(data.DATA);
                    } else {
                        $scope.status.hasphoto = false;
                        fileterObj = editNewspaperService.extractParameters(data, {
                            namekey: 'OWNERTRUENAME',
                            valuekey: 'OWNERNAME',
                            title: '所有者'
                        });
                        $scope.data.ownerArr = fileterObj.nameArr;
                        $scope.data.ownerArr = $filter('unique')($scope.data.ownerArr, 'name');
                        cacheDate(data);
                        $scope.data.word = editNewspaperService.getWordNum(data);
                        openDefaultPanels();
                    }
                    if (!$scope.data.selectOwner) {
                        $scope.data.selectOwner = $scope.data.ownerArr[0];
                    }
                    $scope.data.selectedArray = [];
                    deferred.resolve(data);
                });
                return deferred.promise;
            }

            /**
             * [openDefaultPanels description]  打开默认的PANEL
             * @return {[type]} [description]
             */
            function openDefaultPanels() {
                var tempOpenedPanels = editNewspaperService.getCacheOpenedPanel($scope.status.cacheOpenedPanelKey);
                // console.log(tempOpenedPanels);
                if (angular.isUndefined(tempOpenedPanels)) {
                    $scope.status.isPanelOpenArray[0] = true;
                    return;
                }
                $scope.status.isPanelOpenArray[0] = false;
                for (var i in $scope.data.panels) {
                    if (tempOpenedPanels[$scope.data.panels[i].BANMIANID] === true) {
                        $scope.status.isPanelOpenArray[i] = true;
                        getCachedById(i);
                    }
                }
            }

            /**
             * [getCachedById description]点击版面加载缓存的数据，以提高页面加载速度
             * @param  {[type]} index [description]  panel下标
             * @return {[type]}       [description]
             */
            $scope.getCachedById = function(index) {
                setOpenedPanel(index);
                if ($scope.data.panels[index].DOCUMENTS.length > 0) {
                    return;
                } else {
                    $scope.loadingPromise = getCachedById(index);
                }
            };

            /**
             * [setOpenedPanel description]将panel的开启状态保存到service中
             * @param {[type]} index [description]
             * @return {[type]}       [description]
             */
            function setOpenedPanel(index) {
                for (var i in $scope.status.isPanelOpenArray) {
                    if ($scope.data.panels[i]) {
                        $scope.status.cacheOpenedPanel[$scope.data.panels[i].BANMIANID] = $scope.status.isPanelOpenArray[i];
                    }
                }
                editNewspaperService.cacheOpenedPanel($scope.status.cacheOpenedPanelKey, $scope.status.cacheOpenedPanel);
            }

            /**
             * [getCachedById description] 获取对应panel下缓存的DOCUMENTS 为了展示loadingPromise
             * @param  {[type]} index [description] panel下标
             * @return {[type]}       [description] promise
             */
            function getCachedById(index) {
                var panel = $scope.data.panels[index];
                if (panel.DOCUMENTS.length === 0) {
                    var cache = $cacheFactory.get($scope.status.cachedName);
                    panel.DOCUMENTS = cache.get(panel.BANMIANID);
                }
            }

            /**
             * [requestData description] 分页跳转请求数据得函数
             * @return  {[type]}  [return description]
             */
            $scope.requestData = function() {
                $scope.params.PageIndex = $scope.page.CURRPAGE;
                $scope.params.PageSize = $scope.page.PAGESIZE;
                publicToolService.getModeconfiguration('newspaperDefaultOrderByTime').then((config) => {
                    $scope.data.selectedOrder = (config === 'true' ? editingCenterService.getNewspaperOrder()[1] : editingCenterService.getNewspaperOrder()[0]);
                    requestData();
                },
                () => {
                    requestData();
                });
            };
            // 搜索
            $scope.fullTextSearch = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    $scope.status.isESSearch = true; // stand
                    requestData();
                }
            };

            /**
             * [getESSearchParams description]设置ES检索参数
             * @return {[json]} [description] 参数对象
             */
            function getESSearchParams() {
                var esParams = {
                    serviceid: 'mlf_hybasesearch',
                    methodname: $scope.status.isShowList ? 'queryForPaperDaiYongDocNoPage' : 'queryForPaperDaiYongDoc',
                    searchParams: {
                        PAGESIZE: $scope.page.PAGESIZE + '',
                        PAGEINDEX: $scope.page.CURRPAGE + '',
                        searchFields: [
                            {
                                searchField: $scope.data.selectedConditions.value,
                                keywords: $scope.status.keywords ? $scope.status.keywords : '',
                            },
                            {
                                searchField: 'docType',
                                keywords: $scope.data.selectedDocType.value,
                            },
                            // {
                            //     searchField: 'oprtime',
                            //     keywords: $scope.selectdTimeDefault.value,
                            // },
                            {
                                searchField: 'OwnerName',
                                keywords: $scope.data.selectOwner.value
                            },
                            {
                                searchField: 'paperid',
                                keywords: $stateParams.paperid,
                            },
                            {
                                searchField: '_sort',
                                keywords: $scope.sortType.value,
                            },
                        ],
                    },
                };
                if ($scope.status.isShowList) {
                    esParams.searchParams.searchFields.push({
                        searchField: 'CHANNELID',
                        keywords: $scope.data.BanMian.selectedBanMian.CHANNELID
                    });
                }
                esParams.searchParams = JSON.stringify(esParams.searchParams);
                return esParams;
            }

            /**
             * [newspaperMultiSelected description] 报纸分类多选
             * @param   {[type]}  items  [items description]
             * @param   {[type]}  index  [index description]
             * @return  {[type]}         [return description]
             */
            $scope.newspaperMultiSelected = function(items, index) {
                var judgement = determineItemsInSelectedArray(items);
                if (judgement) {
                    removeItemsInSelectedArray(items);
                    $scope.data.word[index].selcetedWord = 0;
                } else {
                    addItemsToSelectedArray(items, index);
                    // 选中的报纸的字数
                    if (items.length == 0){
                        $scope.data.word[index].selcetedWord = $scope.data.word[index].wordAllCount;
                    } else {
                        var selectedNum = 0;
                        $scope.data.selectedArray.map((item) => {

                            if (items.includes(item)){
                                selectedNum = selectedNum + Number(item.DOCWORDSCOUNT);
                            }
                        });
                        $scope.data.word[index].selcetedWord = selectedNum;
                    }
                }
                $scope.loadingPromise = editNewspaperService.getAllBMRights($scope.data, $state.params.paperid, $scope.data.panels[index].DOCUMENTS[0].CHANNELID, 'paper.dyg').then(function(data) {
                    $scope.status.btnRights = data;
                });
            };

            /**
             * [removeItemsInSelectedArray description] 将对象数组从已选中移除
             * @param  {[array]} items [description] array
             * @return {[type]}       [description]
             */
            function removeItemsInSelectedArray(items) {
                for (var i = 0; i < items.length; i++) {
                    var index = $scope.data.selectedArray.indexOf(items[i]);
                    if (index > -1) {
                        $scope.data.selectedArray.splice(index, 1);
                    }
                }
            }

            /**
             * [addItemsToSelectedArray description]；将对象数组加入到已选数组中
             * @param {[type]} items [description] 传入的对象数组
             * @param {[type]} index [description] 
             * @return {[type]}       [description]
             */
            function addItemsToSelectedArray(items, index) {
                if (items.length === 0) {
                    $scope.status.isPanelOpenArray[index] = true;
                    $scope.getCachedById(index);
                    items = $scope.data.panels[index].DOCUMENTS;
                }
                for (var i = 0; i < items.length; i++) {
                    var index = $scope.data.selectedArray.indexOf(items[i]);
                    if (index < 0 && items[i].PAPERSTATUSNAME !== '待修订') {
                        $scope.data.selectedArray.push(items[i]);
                    }
                }
            }
            $scope.determineItemsInSelectedArray = function(items) {
                return determineItemsInSelectedArray(items);
            };

            /**
             * [determineItemsInSelectedArray description] 判断对象全部在已选列表中
             * @param  {[type]} items [description]
             * @return {[object]}       [description]  isAllIn :true 全在；
             */
            function determineItemsInSelectedArray(items) {
                if (items.length === 0) {
                    return false;
                }
                var reviseNum = 0;
                for (var i = 0; i < items.length; i++) {
                    if (items[i].PAPERSTATUSNAME !== '待修订' && $scope.data.selectedArray.indexOf(items[i]) < 0) {
                        return false;
                    } else if (items[i].PAPERSTATUSNAME === '待修订') {
                        reviseNum++;
                    }
                }
                if (reviseNum === items.length) {
                    return false;
                }
                return true;
            }


            /**
             * [initDropDown description] 初始化下拉框
             * @return  {[type]}  [return description]
             */
            function initDropDown() {
                // 初始化选择日期
                $scope.selectdTime = initSingleSelecet.newspaperDraftTime();
                $scope.selectdTimeDefault = angular.copy($scope.selectdTime[3]);
                // 初始化选择类型
                $scope.docTypeJsons = initSingleSelecet.newspaperDraftType();
                $scope.data.selectedDocType = angular.copy($scope.docTypeJsons[0]);
                // 初始化选择状态
                $scope.data.todayManuStatusArray = initSingleSelecet.standbyOrPageManuStatus();
                $scope.data.todayManuStatusArray.splice(1, 0, {
                    name: '待用稿',
                    value: '31',
                }); // 加入待用稿选项
                $scope.data.SelectedTodayManuStatus = angular.copy($scope.data.todayManuStatusArray[0]);
                // 排序方式
                $scope.sortTypeJsons = initSingleSelecet.sortType();
                $scope.sortType = angular.copy($scope.sortTypeJsons[1]);

                $scope.data.conditionsSearch = editNewspaperService.newspaperEntire();
                $scope.data.selectedConditions = angular.copy(editNewspaperService.newspaperEntire()[0]);

                // 版面
                editNewspaperService.screenFilter($state.params.paperid).then(function(data) {
                    $scope.data.BanMian.BanMianArray = data;
                    $scope.data.BanMian.selectedBanMian = data[0];
                });
                // editingCenterService.dealStorage($scope);
            }

            /**
             * [queryByDropdown description] 筛选条件触发后请求数据
             * @param  {[type]} key   [description] 请求对象参数key
             * @param  {[type]} value [description] 请求对象值
             * @return {[type]}       [description] null
             */
            $scope.queryByDropdown = function(key, value) {
                if (key === 'ChannelId') {
                    $scope.loadingPromise = editNewspaperService.getBMRights($scope.data.AllBMRights, value, $stateParams.paperid, 'paper.dyg').then(function(data) {
                        $scope.status.btnRights = data;
                    });
                }
                // 折叠模式版面筛选不走接口
                if (key === 'ChannelId' && !$scope.status.isShowList) {
                    return;
                }
                // 下拉框判断;
                if (key === 'DocType' && value === '2') {
                    $scope.status.hasphotoflag = true;
                }
                $scope.params[key] = value;
                $scope.page.CURRPAGE = 1;
                requestData();
            };

            /**
             * [selectDoc description] 单选
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.selectDoc = function (item) {
                $scope.selectItemList(item);
            };

            /**
             * [goToDetail description]图集模式跳转细览页
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.goToDetail = function(item){
                $scope.newspaperPreview(item);
            };


            /**
             * [rejection description]退稿
             * @return {[type]} [description]
             */
            $scope.rejection = function() {
                rejectionDraftofPage($scope.data.selectedArray);
            };

            /**
             * [rejectionDraftofPage description]
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            function rejectionDraftofPage(item) {
                var transferDate = {
                    items: item,
                    PaperDocIds: trsspliceString.spliceString(item, 'METADATAID', ','),
                };
                editNewspaperService.newspaperBackManuscript(
                    transferDate,
                    function(result) {
                        requestData();
                    },
                    function() {
                        requestData();
                    }
                );
            }

            /**
             * [xiuding description]修订
             * @return {[type]} [description]
             */
            $scope.xiuding = function() {
                var transferData = {
                    serviceid: 'mlf_papermodify',
                    methodname: 'appointDocToUserOfDyg',
                    PaperId: $stateParams.paperid,
                    PaperDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                    selectedArray: $scope.data.selectedArray
                };
                newMediaService.revise($scope, transferData);
            };

            /**
             * [promptRequest description]具体操作数据请求成功后刷新列表
             * @param  {[obj]} params [description]请求参数
             * @param  {[string]} info   [description]提示语
             * @return {[type]}        [description]
             */
            function promptRequest(params, info) {
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                    function(data) {
                        modalDialog.alertType('', info, 'success', false, function() {
                            requestData();
                        });
                    },
                    function() {
                        requestData();
                    }
                );
            }

            /**
             * [exportDraft description]批量导出
             * @return {[type]} [description] null
             */
            $scope.exportDraft = function() {
                editingCenterService.newsPaperExportDraft($scope);
            };

            /**
             * [draftlist description]发稿单（array, params, success）
             * @return {[type]} [description] 
             */
            $scope.draftlist = function() {
                newMediaService.draftlist($scope, {
                    serviceid: 'mlf_appfgd',
                    methodname: 'paperDaiYongbatchUpdateFgdUsers',
                });
            };

            /**
             * [batchCollect description]批量稿件收藏
             * @return {[type]} [description] null
             */
            $scope.batchCollect = function() {
                editNewspaperService.collectDraft($scope, 'collectDaiYong');
            };

            /**
             * [collectDraft description] 稿件收藏
             * @param   {[type]}  array  [array description]
             * @return  {[type]}         [return description]
             */
            function collectDraft(array) {
                var params = {
                    serviceid: 'mlf_paper',
                    methodname: 'collectDaiYong',
                    MetaDataIds: array,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('收藏成功', '', 'success', false, function() {
                        requestData($scope.params);
                    });
                });
            }

            /**
             * [shangban description] 上版操作
             * @return  {[type]}  [return description]
             */
            $scope.shangban = function() {
                newMediaService.shangBan($scope);
            };

            /**
             * [archive description]归档操作
             * @return {[type]} [description]
             */
            $scope.archive = function() {
                // modalDialog.inputModel('归档', '归档意见（可选）', function(content) {
                //     modalDialog.confirmModal('归档', '确认归档所选稿件', function() {
                //         var params = {
                //             serviceid: 'mlf_paper',
                //             methodname: 'doGuiDang',
                //             Option: content,
                //             SrcDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                //             SrcBanMianIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLID', ','),
                //         };
                //         promptRequest(params, '归档成功');
                //     });
                // });
                editNewspaperService.archive($scope.data.selectedArray,
                    function(data) {
                        modalDialog.alertType('', '归档成功', 'success', false, function() {
                            requestData();
                        });
                    },
                    function() {
                        requestData();
                    });
            };

            /**
             * [printBtn description] 批量打印
             * @return  {[type]}  [return description]
             */
            $scope.printBtn = function() {
                const chnlDocIds = $scope.data.selectedArray.map((item) => item.CHNLDOCID).join(',');
                editingCenterService.isListDocCanOper(chnlDocIds, $scope.requestData).then(function(data){
                    var chnlDocIdsArray = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                    var params = {
                        serviceid: 'mlf_paper',
                        methodname: 'queryViewDatas',
                        MetaDataIds: chnlDocIdsArray,
                    };

                    /**
                 * [requestVersion description]
                 * @return  {[type]}  [return description]
                 */
                    function requestVersion() {
                        var idsArray = trsspliceString.getArrayString($scope.data.selectedArray, 'METADATAID', ',').split(',');
                        var versionResult = {};
                        var count = 0;
                        var defer = $q.defer();
                        angular.forEach(idsArray, function(value, key) {
                            trsHttpService
                                .httpServer(
                                    trsHttpService.getWCMRootUrl(),
                                    {
                                        serviceid: 'mlf_metadatalog',
                                        methodname: 'query',
                                        MetaDataId: value,
                                    },
                                    'get'
                                )
                                .then(function(data) {
                                    versionResult[value] = data.DATA;
                                    count++;
                                    if (count == idsArray.length) {
                                        defer.resolve(versionResult);
                                    }
                                });
                        });
                        return defer.promise;
                    }
                    $scope.loadingPromise = $q
                        .all([trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get'), requestVersion()])
                        .then(function(data) {
                            var detail = data[0];
                            var version = data[1];
                            for (var i = 0; i < detail.length; i++) {
                                detail[i].VERSION = version[detail[i].METADATAID];
                                if (i + 1 == detail.length) {
                                    trsPrintService.trsPrintDocument(detail);
                                }
                            }
                        });
                });
            };

            /**
             * [filterChnlid description]过滤版面ID
             * @param  {[obj]} elm [description]每个选中项的版面ID
             * @return {[type]}     [description]
             */
            $scope.banmianFilter = function(elm) {
                if (angular.isDefined(elm.CHNLID)) {
                    return elm.CHNLID === $scope.data.selectedArray[0].CHNLID;
                }
            };

            /**
             * [zhuanban description] 转版
             * @return  {[type]}  [return description]
             */
            $scope.zhuanban = function() {
                newMediaService.zhuanBan($scope);
            };
            // 流程版本与操作日志
            $scope.showVersionTime = function(item) {
                editingCenterService.getVersionTime(item, false);
            };
            // 稿件关联弹窗
            $scope.draftCorrelationView = function(id) {
                editNewspaperService.draftCorrelationViews(id, $stateParams.paperid, 0);
            };

            // 外发
            $scope.outSending = function() {
                editingCenterService.outSending($scope.data.selectedArray, function(result) {
                    outSendingDraft(result.selectItems);
                }, function(){
                    $scope.requestData();
                });
            };

            /**
             * [isLockEdit description]
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.isLockEdit = function(item) {
                $scope.loadingPromise = editNewspaperService.getBMRights($scope.data.AllBMRights, item.CHANNELID, $stateParams.paperid, 'paper.dyg').then(function(rights) {
                    if (item.PAPERSTATUSNAME !== '待修订' && rights['paper.dyg.bianji']) {
                        editingCenterService.isListDocCanOper(item.CHNLDOCID, $scope.requestData).then(function(data){
                            item.newspapertype = $scope.status.dygedit;
                            item.MEDIATYPE = item.MEDIATYPE || '3';
                            editingCenterService.routerToEditorWithLock(item);
                        });
                    } else {
                        var url = $state.href('newspaperNewsPreview', { paperid: item.SITEID, bzmetadata: item.METADATAID, newspapertype: $scope.status.dygpreview, paperstatusname: item.PAPERSTATUSNAME, channelid: item.CHANNELID});
                        window.open(url);
                    }
                });
            };

            /**
             * [outSendingDraft description] 邮件外发
             * @param   {[type]}  items  [items description]
             * @return  {[type]}         [return description]
             */
            function outSendingDraft(items) {
                var userids = trsspliceString.spliceString(items, 'EMAIL', ',');
                var draftids = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                var params = {
                    serviceid: 'mlf_mailoutgoingOper',
                    methodname: 'paperDaiYongGaoSendEmail',
                    Emails: userids,
                    MetaDataIds: draftids,
                };
                promptRequest(params, '邮件外发成功');
            }

            /**
             * [newspaperPreview description] 报纸预览
             * @param  {[type]} item [description] 当前对象
             */
            /**
             * [newspaperPreview description] 报纸预览
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            $scope.newspaperPreview = function(item) {
                var paramsstateParams = {
                    paperid: item.SITEID,
                    bzmetadata: item.METADATAID,
                    newspapertype: $scope.status.dygpreview,
                    paperstatusname: item.PAPERSTATUSNAME,
                    channelid: item.CHANNELID
                };
                var url = $state.href('newspaperNewsPreview', paramsstateParams);
                window.open(url);
                storageListenerService.previewPageTurningStorage($scope.data.daiyongDocsList, 'METADATAID,SITEID,DOCTYPEID', 'newspaperPreview'); // news
            };

            /**
             * [getReviseInfo description] 获取修订信息
             * @param {object} [item] [description] 稿件信息
             * @return {[type]} [description]
             */
            $scope.getReviseInfo = newMediaService.getReviseInfo;

            /**
             * [manuscriptShare description] 稿件分享
             * @param   {[object]}  item  [item description] 稿件信息
             * @return  {[type]}          [return description]
             */
            $scope.manuscriptShare = function(item) {
                $scope.loadingPromise = editingCenterService.manuscriptShare(item, function(data) {
                    requestData();
                });
            };

            /** *************************list模式方法**************************/
    
            /**
             * [pageChanged description] 换页
             *
             * @return  {[type]}  [return description]
             */
            $scope.pageChanged = function() {
                requestData();
            };
    
            /**
             * [selectAllList description] 全选
             *
             * @return  {[type]}  [return description]
             */
            $scope.selectAllList = function() {
                $scope.data.selectAllWords = 0;
                if ($scope.data.selectedArray.length === $scope.data.filterReviseItem.length) {
                    $scope.data.selectedArray = [];
                } else {
                    $scope.data.selectedArray = [].concat($scope.data.filterReviseItem);
                    $scope.data.filterReviseItem.forEach(function(item) {
                        $scope.data.selectAllWords += parseInt(item.DOCWORDSCOUNT);
                    });
                }
            };
    
            /**
             * [selectItemList description] 单选
             *
             * @param   {[type]}  item   [item description]
             * @param   {[type]}  index  [index description]
             *
             * @return  {[type]}         [return description]
             */
            $scope.selectItemList = function(item) {
                var index = $scope.data.selectedArray.indexOf(item);
                if (index === -1) {
                    $scope.data.selectedArray.push(item);
                    $scope.data.selectAllWords += parseInt(item.DOCWORDSCOUNT);
                } else {
                    $scope.data.selectedArray.splice(index, 1);
                    $scope.data.selectAllWords -= parseInt(item.DOCWORDSCOUNT);
                }
                $scope.loadingPromise = editNewspaperService.getAllBMRights($scope.data, $state.params.paperid, item.CHANNELID, 'paper.dyg').then(function(data) {
                    $scope.status.btnRights = data;
                });
            };

            /**
         * [atlasMode description] 图集模式
         * @return {[type]} [description]
         */
            $scope.atlasMode = function() {
            // $scope.departListParams.CurrPage = $scope.page.CURRPAGE = 1;
                $scope.status.hasphoto = !$scope.status.hasphoto;
                $scope.status.hasphotoflag = !$scope.status.hasphotoflag;
            };
            
            /**
             * [changeMode description] 切换时折叠模式还是列表模式
             *
             * @return  {[type]}  [return description]
             */
            $scope.changeMode = function() {
                // $scope.page.PAGESIZE = 50;
                $scope.page.CURRPAGE = 1;
                $scope.data.panels = [];
                $scope.status.isShowList = !$scope.status.isShowList;
                requestData();
            };
        },
    ]);
